const getCurrentUserName = ({ account, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (account && account['First Name'] && account['Last Name']) {
    return `${account['First Name']} ${account['Last Name']}`;
  }

  return '';
};

export default getCurrentUserName;



// WEBPACK FOOTER //
// ./src/utils/print/getCurrentUserName.js